import { render } from "./NewsRoomContent.vue?vue&type=template&id=71e5bcfe"
import script from "./NewsRoomContent.vue?vue&type=script&lang=js"
export * from "./NewsRoomContent.vue?vue&type=script&lang=js"

import "./NewsRoomContent.vue?vue&type=style&index=0&id=71e5bcfe&lang=css"

import exportComponent from "/var/www/digiasia.asia.bak/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__